import {
  DialogContent,
  TableHead,
  InputAdornment,
  Table,
  TableContainer,
  TableBody,
} from '@mui/material';
import { CloseRounded, SearchRounded } from '@mui/icons-material';
import { useState } from 'react';
import {
  downloadDialog,
  downloadTable,
} from '~/components/Global/Dialog/Dialog.style';
import { FileDownloadDialogItem } from './FileDownloadDialogItem';
import { TFileCatalog } from '~/store/file/file.type';

type TProp = {
  handleClose: () => void;
  open: boolean;
  labels: string[];
  list: TFileCatalog[];
};

export const FileDownloadDialog = ({ handleClose, open, list }: TProp) => {
  const [searchKey, setSearchKey] = useState('');

  return (
    <downloadDialog.dialog open={open} onClose={handleClose}>
      <downloadDialog.title>
        <downloadDialog.titleContent>
          <downloadDialog.titleText>單一檔案下載</downloadDialog.titleText>
          <downloadDialog.textfield
            value={searchKey}
            onChange={event => {
              setSearchKey(event.target.value);
            }}
            placeholder="請輸入搜尋名稱"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRounded />
                </InputAdornment>
              ),
            }}
          />
        </downloadDialog.titleContent>
        <CloseRounded
          sx={{ fontSize: '26px', cursor: 'pointer' }}
          onClick={handleClose}
        />
      </downloadDialog.title>
      <DialogContent sx={{ overflow: 'hidden' }}>
        <TableContainer component="div" sx={{ height: '100%' }}>
          <Table stickyHeader sx={{ overflow: 'auto' }}>
            <TableHead>
              <downloadTable.headRow>
                <downloadTable.cell width="100%" isHeader>
                  檔案名稱
                </downloadTable.cell>
                <downloadTable.cell width="120px" isHeader>
                  檔案大小
                </downloadTable.cell>
                <downloadTable.cell width="232px" isHeader />
              </downloadTable.headRow>
            </TableHead>
            <TableBody>
              {list.map(data => {
                return (
                  <FileDownloadDialogItem
                    data={data}
                    key={data.resource.file.url}
                  />
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </downloadDialog.dialog>
  );
};
